import React from 'react';
import { connect } from 'react-redux';
import { states } from '@/constants/lifecycle';
import {
  columnCreatedOn,
  columnDescription,
  columnMultiSelect,
  columnNameLink,
  columnPublisher,
  columnCollections,
  columnStatus,
  columnTools,
  columnUpdatedOn,
  columnVisibility,
} from '@/constants/fields';
import { presentationOptions } from '@/constants/states';
import paging, { onCategoryScroll } from '@/hooks/paging';
import CardsHeader from '@/components/cards/CardsHeader';
import DatasetsTable from '../components/DatasetsTable';
import DatasetsPanelContainer, {
  mapDispatchToProps,
  mapStateToProps,
} from '../components/DatasetsPanelContainer';
import DatasetCards from '../components/DatasetCards';
import DatasetsFilters from './DatasetsFilters';
import DatasetsDataModelFilter from '../datamodels/components/DatasetsDataModelFilter';

const buildColumns = (allowMultiSelect, allowStatus) => {
  const columns = [columnNameLink,
    columnDescription,
    columnCreatedOn,
    columnUpdatedOn,
    columnPublisher,
    columnCollections,
    columnVisibility,
    columnTools];
  if (allowMultiSelect) {
    columns.push(columnMultiSelect);
  }
  if (allowStatus) {
    columns.push(columnStatus);
  }
  return columns;
};

const DatasetsPanelFull = ({
  allowDataModelRead,
  allowMultiSelect,
  allowStatus,
  canCreate,
  canRead,
  category,
  currentPage,
  datasets,
  fetchData,
  display,
  newDatasetCode,
  onCheckBoxClick,
  pageCount,
  pageSize,
  readErrors,
  readStatus,
  theme,
  togglePresentation,
  total,
}) => {
  paging.useFetchByCategory(fetchData, category, readStatus);

  return (
    <DatasetsPanelContainer readErrors={readErrors} canRead={canRead} className="aridhia-datasets-panel-full">
      {display === presentationOptions.CARDS && (
      <>
        <CardsHeader
          disabled={readStatus === states.PENDING}
          onClick={() => togglePresentation(category, presentationOptions.TABLE)}
        >
          { allowDataModelRead && <DatasetsDataModelFilter category={category} className="mr-10" /> }
          <DatasetsFilters category={category} className="aridhia-list-filter" />
        </CardsHeader>
        <DatasetCards
          canCreate={canCreate}
          handleScroll={() => onCategoryScroll(fetchData, category, currentPage, pageCount, pageSize)}
          items={datasets}
          newDatasetCode={newDatasetCode}
          onCheckBoxClick={allowMultiSelect ? (value) => onCheckBoxClick(category, value) : undefined}
          readErrors={readErrors}
          readStatus={readStatus}
          showStatus
          showTools
        />
      </>
      )}
      {display !== presentationOptions.CARDS && (
      <DatasetsTable
        allowDataModelRead={allowDataModelRead}
        datasets={datasets}
        readStatus={readStatus}
        readErrors={readErrors}
        category={category}
        total={total}
        pageCount={pageCount}
        pageSize={pageSize}
        currentPage={currentPage}
        fetchData={fetchData}
        canCreate={canCreate}
        columns={buildColumns(allowMultiSelect, allowStatus)}
        onCheckBoxClick={onCheckBoxClick}
        newDatasetCode={newDatasetCode}
        theme={theme}
      />
      )}
    </DatasetsPanelContainer>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(DatasetsPanelFull);
